import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Helmet from 'react-helmet';

import Nav from './Nav';
import Footer from './Footer';
import { scrollToHashOrTop } from '../utils/scroll';

/**
 * Global chrome for every route: noise, fixed nav, content offset, footer.
 */
export default function AppShell({ children }) {
  const location = useLocation();
  const isHome = location.pathname === '/';
  // The admin console is a full-screen, org-branded surface — it renders its own
  // chrome, so skip the marketing nav/footer entirely.
  const isConsole = location.pathname.startsWith('/console');

  useEffect(() => {
    // Wait until home sections are in the DOM before scrolling to a hash.
    const timer = window.setTimeout(() => {
      scrollToHashOrTop(location.hash);
    }, isHome ? 0 : 50);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash, isHome]);

  if (isConsole) {
    return <>{children}</>;
  }

  return (
    <>
      <Helmet
        title="Range Drills: Shoot Better, Hit Your Mark"
        meta={[
          {
            name: 'description',
            content:
              'Range Drills turns range time into structured training. Proven drills, real progress tracking, and Jacob, your AI shooting coach, in your pocket. Free on iOS and Android.',
          },
        ]}
      >
        <html lang="en" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Saira:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <div className={`site-main${isHome ? '' : ' site-main--offset'}`}>
        {children}
      </div>
      <Footer />
    </>
  );
}
